import MosqueCard from './MosqueCard';

const MosqueList = ({ mosques, loading }) => {
  // console.log("mosques", mosques);
  if (loading) {
    return (
      <div className="mosque-list__loading">
        Loading mosques...
      </div>
    );
  }

  if (!mosques.length) {
    return (
      <div className="mosque-list__empty">
        No mosques found in this district.
      </div>
    );
  }

  return (
    <div className="mosque-list">
      {mosques.map(mosque => (
        <MosqueCard key={mosque._id} mosque={mosque} />
      ))}
    </div>
  );
};

export default MosqueList; 